<template>

  <div>
    <!-- 右侧更多服务按钮 -->
    <div class="side-more-services">
      <button
          class="side-more-btn"
          @click="showMoreMenu = !showMoreMenu"
      >
        <span class="arrow"><<</span>
        <span>更多服务</span>
      </button>
      <div v-if="showMoreMenu" class="side-more-panel">
        <div class="side-panel-title">
          <span>更多服务</span>
          <button class="side-panel-close" @click="showMoreMenu = false">
            <i class="fas fa-chevron-up"></i>
          </button>
        </div>
        <button class="side-panel-item side-panel-item-highlight" @click="handleAIRobot">
          <div class="item-icon-wrapper">
            <i class="fas fa-robot"></i>
          </div>
          <span class="item-text">AI替你播</span>
        </button>
        <button class="side-panel-item" @click="handleAPIIntegration">
          <div class="item-icon-wrapper">
            <i class="fas fa-link"></i>
          </div>
          <span class="item-text">API对接</span>
        </button>
      </div>
    </div>
    <!-- API对接弹窗 -->
    <div v-if="showAPIModal" class="modal-overlay" @click.self="closeAPIModal">
      <div class="modal-container">
        <div class="modal-wrapper api-modal">
          <div class="modal-header api-header">
            <h3 class="modal-title">获取API KEY</h3>
            <button class="modal-close" @click="closeAPIModal">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body api-body">
            <div class="engine-selector">
              <div
                  class="engine-card active"

              >
                <div class="engine-icon volcano-icon">
                  <i class="fas fa-flame"></i>
                </div>
                <div class="engine-badge">建议使用</div>
                <span class="engine-name">火山引擎</span>
              </div>

            </div>

            <div class="api-input-section">
              <label class="api-label">API KEY:</label>
              <div class="input-with-tip">
                <input
                    type="text"
                    v-model="key"
                    class="api-input"
                    placeholder="输入API KEY"
                >

              </div>
            </div>


          </div>
          <div class="modal-footer api-footer">
            <button class="btn btn-test" @click="saveAPIModal">保存配置</button>
            <button class="btn btn-primary api-submit"
                    @click="handleUrl('https://console.volcengine.com/ark/region:ark+cn-beijing/apiKey')">点击申请
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- AI替你播弹窗 -->
    <div v-if="showAIRobotModal" class="modal-overlay" @click.self="closeAIRobotModal">
      <div class="modal-container-wide">
        <div class="modal-wrapper ai-robot-modal">
          <div class="modal-header ai-robot-header">
            <div class="header-icon">
              <i class="fas fa-robot"></i>
            </div>
            <h3 class="modal-title">AI替你播</h3>
            <button class="modal-close" @click="closeAIRobotModal">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="ai-robot-content">
              <!-- 参考话术区域 -->
              <div class="robot-panel left-panel">
                <div class="panel-header robot-header">
                  <div class="panel-icon orange-icon">
                    <i class="fas fa-file-text"></i>
                  </div>
                  <h4 class="panel-title">参考话术</h4>
                  <div class="header-buttons">
                    <button class="text-btn text-btn-import" @click="triggerTextUpload">
                      导入话术
                    </button>
                    <button class="text-btn text-btn-export" @click="downloadText">
                      导出话术
                    </button>
                    <input
                        type="file"
                        accept=".txt"
                        class="text-file-input"
                        @change="handleTextUpload"
                        ref="textFileInput"
                    >
                  </div>
                </div>
                <div class="panel-body">
                  <div class="textarea-container">
                    <textarea class="robot-textarea" placeholder="请输入参考话术内容，我会按照您的指示进行直播..."
                              v-model="texts" @keyup="saveData('texts')"></textarea>
                    <span class="word-count-floating">{{ texts.length }}字</span>
                  </div>
                  <!-- 音频上传区域 -->
                  <div class="audio-upload-section">
                    <div class="audio-upload-btn" @click="triggerAudioUpload">
                      <i class="fas fa-upload"></i>
                      <span>上传音频</span>
                    </div>
                    <input
                        type="file"
                        accept="audio/*"
                        class="audio-file-input"
                        @change="handleAudioUpload"
                        ref="audioFileInput"
                    >


                  </div>
                </div>
              </div>

              <!-- 产品信息区域 -->
              <div class="robot-panel right-panel">
                <div class="panel-header robot-header">
                  <div class="panel-icon blue-icon">
                    <i class="fas fa-box"></i>
                  </div>
                  <h4 class="panel-title">话术产品信息替换</h4>
                  <div class="example-dropdown">
                    <select v-model="currentExample" @change="loadExample">
                      <option value="fashion">服饰示例</option>
                      <option value="department">百货示例</option>
                      <option value="food">食品示例</option>
                    </select>
                  </div>
                </div>
                <div class="panel-body product-info-panel">
                  <div class="product-item full">
                    <label>产品信息替换</label>
                    <textarea class="product-textarea" v-model="productInfo" @keyup="saveData('productInfo')"
                              placeholder="请输入产品信息，格式示例：
主播信息：
产品名称：
价格：
规格：
材质：
卖点：
颜色：
发货时间：
适合人群：
季节：
备注：
话术要求："></textarea>
                  </div>
                </div>
              </div>
            </div>

            <!-- 配置区域容器 -->
            <div class="sections-row">
              <!-- 用户接待区域 -->
              <div class="practice-section">
                <div class="section-header">
                  <h4><i class="fas fa-handshake"></i> 用户接待</h4>
                </div>
                <div class="practice-options">
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="userReception.enterWelcome">
                    <span>进入欢迎</span>
                    <input type="number" class="mini-input" v-model="userReception.enterWelcomeInterval">
                    <span>秒随机</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="userReception.publicReply">
                    <span>AI智能回复</span>
                    <input type="number" class="mini-input" v-model="userReception.publicReplyInterval">
                    <span>秒随机</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="userReception.useAnchorReply">
                    <span>助播声音回复</span>
                  </label>
                </div>
              </div>
              <!-- 主播配置区域 -->
              <div class="config-section">
                <div class="section-header">
                  <h4><i class="fas fa-sliders-h"></i> 功能开关</h4>
                </div>
                <div class="config-options">
                  <button class="btn btn-start" :class="{'btn-start-active':aiPlayStatus}" @click="handleAi">
                    {{ aiPlayStatus ? '停止' : '启动' }}AI替你播
                  </button>
                  <button class="btn btn-start" v-if="aiPlayStatus" :class="{'btn-start-active':is_pay}" @click="switchPay">
                    {{ is_pay ? '暂停' : '继续' }}
                  </button>



                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import gradioMod from "@/utils/gradio-index"

import http from "@/utils/http";
import {checkAuduiSrc, delay, extractChineseCharacters, getRandomInt, getYmdHm, randomText} from "@/utils/function";
import {chat} from "@/utils/Ai";

let audioText, insertVoice, audioFileToText

export default {
  name: 'floatMenu',
  data() {
    return {

      showMoreMenu: false,
      showAPIModal: false,
      showAIRobotModal: false,
      texts: "",
      currentExample: 'fashion',
      productInfo: "",
      key: null,
      is_pay:true,

      examples: {
        fashion: {
          name: '服饰示例',
          productInfo: `主播信息：主播1米59体重108斤 试穿M码
产品名称：1号链接条纹天丝衬衫
价格：1号链接29.9
规格：80到105斤穿M码，106斤到119斤穿L码，120斤到129斤穿一个加，
材质：天丝料
卖点：透气、亲肤舒适
颜色：这款产品有2种颜色黑色，白色，主推色是黑色。
发货时间：48小时内 三通一达
适合人群：女性
季节：夏季
备注：有运费险
话术要求：`
        },
        department: {
          name: '百货示例',
          productInfo: `产品名称：高速电风扇
价格：1号链接9.9
规格：16村扇面 8档风速
材质：
颜色：2种颜色 黑色，白色，主推色是黑色。
卖点：风力大，可控风速
发货时间：48小时内 三通一达
适合人群：
季节：夏季
备注：没运费险 有7天无理由
话术要求：`
        },
        food: {
          name: '食品示例',
          productInfo: `产品名称：桂圆莲子八宝粥
价格：1号链接9.9
规格：一箱6瓶 每瓶320克
卖点：好喝健康
发货时间：48小时内 三通一达
适合人群：男女老少
季节：夏季
备注：没运费险 有7天无理由
话术要求：`
        }
      },
      userReception: {
        // 进入欢迎
        enterWelcome: false,
        // 进入欢迎时间间隔
        enterWelcomeInterval: 60,
        // 公屏回复开关
        publicReply: false,
        // 公屏回复时间间隔
        publicReplyInterval: 60,
        // 用助播回复
        useAnchorReply: false,
      },
    }
  },
  watch: {
    userReception: {
      handler() {
        this.$store.commit("setUserReception", this.userReception);
      },
      deep: true,
    },
    texts(newVal) {
      this.$store.commit("setReferenceText", newVal)
    },
    showMoreMenu() {
      this.key = this.$store.state.apiKey
    }

  },
  async mounted() {

    const mod = await gradioMod;
    ({audioText, insertVoice, audioFileToText} = mod);

    this.currentExample = localStorage.getItem("currentExample") || 'fashion';

    this.loadExample();

    const texts = localStorage.getItem("texts");
    const productInfo = localStorage.getItem("productInfo");

    this.productInfo = productInfo || this.$store.state.productInfo;
    this.texts = texts || this.$store.state.referenceText;
    this.key = this.$store.state.apiKey;

    this.userReception = this.$store.state.userReception;

  },
  computed: {
    referenceText() {
      return this.$store.state.referenceText;
    },
    currentGroupTalks() {
      return this.talks[this.activeTab] || []
    },
    aiPlayStatus() {
      return this.$store.state.aiPlayStatus;
    },
    apiKey() {
      return this.$store.state.apiKey;
    },


  },
  methods: {

    async switchPay(){

      if(this.$store.state.anchorAudio.paused){
        this.is_pay = true;
        this.$store.state.anchorAudio.play();
      }else{
        this.is_pay=false;

        this.$store.state.anchorAudio.pause();
      }

    },
    async saveData(type) {

      localStorage.setItem(type, this[type])

    },


    closeAPIModal() {
      this.showAPIModal = false
    },

    async saveAPIModal() {

      const res = await http.post("api/ai/setKey", {key: this.key});
      if (res.code == 200) {
        this.$store.commit("setApiKey", this.key);
        this.$dialog.tips({
          message: res.msg,
          type: "success"
        })
        this.closeAPIModal();
        return;
      }

      this.$dialog.tips({
        message: res.msg,
        type: "error"
      })


    },

    handleAi() {

      if (!this.$store.state.ttsStatus) {
        this.$dialog.tips({
          message: "正在启动中...",
          type: "warning"
        })
        return;
      }


      if (!this.checkConfig()) {
        return;
      }

      this.$store.commit("setAiPlayStatus", !this.$store.state.aiPlayStatus)
      if (this.aiPlayStatus) {
        this.voiceAudioList = [];
        this.$store.commit("setProductInfo", this.productInfo)
        this.$store.commit("setAIEnabled", false)
        this.$store.commit("setAIReplyEnabled", false)
        this.startAudio();
        this.is_pay=true;
      } else {
        this.voiceAudioList = [];
        this.$store.state.anchorAudio.pause();
        this.$dialog.tips({
          message: 'AI替你播已经关闭',
        })
      }

    },

    async metKeyword(data) {
      const res = await http.post("api/voice/work", {
        content: data.content,
      })
      if (res.code == 200) {
        return res.data
      }


      return false;


    },

    handleUrl(url) {

      window.open(url)
    },

    async keywordAi() {
      if (this.$store.state.aiPlayStatus && this.$store.state.userReception.publicReply) {
        const timer = getRandomInt(0, this.$store.state.userReception.publicReplyInterval) * 1000;
        const contentData = this.$store.state.liveData.messageData;
        if (contentData.content != this.$store.state.liveKeyword) {
          const res = await this.metKeyword(contentData)
          if (res) {
            this.$store.commit("setLiveKeyword", contentData.content)
            if (!checkAuduiSrc(this.$store.state.keywordAudio)) {
              if (this.$store.state.userReception.useAnchorReply) {
                var blob = await insertVoice(res, "keyword");
              } else {
                var blob = await insertVoice(res, "anchor");
              }

              console.log(blob)
              this.$store.state.keywordAudio.src = blob;
            }
          }
        }
        await delay(timer)
        this.keywordAi();
        return
      }
      await delay(1000)
      this.keywordAi();


    },
    createText(list) {
      console.log("list", list)
      const arr = [];
      list.forEach(async v => {
        var content = "";
        if (v.rewrites && v.rewrites.length > 0) {
          content = v.rewrites[Math.floor(Math.random() * v.rewrites.length)]
        } else {
          content = v.content;
        }

        content = randomText(content);
        arr.push({
          type: v.talk_type,
          content,
        });
      })

      return arr;

    },


    async setWords(talk_id) {
      if (this.$store.state.aiPlayStatus) {
        const list = await this.Db("话术列表").where("talk_id", talk_id).select();
        const contentList = await this.createText(list);
        return contentList;
      }

    },

    async welcomeAi() {
      if (this.$store.state.aiPlayStatus && this.$store.state.userReception.enterWelcome) {
        const timer = getRandomInt(0, this.$store.state.userReception.enterWelcomeInterval) * 1000;
        if (this.$store.state.liveData.room_nickname) {
          const res = await this.setWords(this.$store.state.modules.welcome?.id);
          if (res) {
            var text = res[getRandomInt(0, res.length - 1)].content;
            text = text.replaceAll("{时间}", getYmdHm()).replaceAll("{人数}", this.$store.state.liveData.userCount || 0).replaceAll("{名字}", this.$store.state.liveData.room_nickname);
            this.$store.commit("setLiveData", {
              type: "room_nickname",
              data: ""
            });

            if (!checkAuduiSrc(this.$store.state.welcomeAudio)) {
              const blob = await insertVoice(text, "welcome");
              this.$store.state.welcomeAudio.src = blob;
            }
          }
        }
        await delay(timer)

        this.welcomeAi();

        return
      }

      await delay(1000)
      this.welcomeAi();


    },

    async startAudio() {
      if (this.$store.state.aiPlayStatus) {

        this.welcomeAi();
        this.keywordAi();

        this.createVoiceList();
        this.$dialog.loading({text: "AI预热中..."});
        while (true) {
          if (this.voiceAudioList.length >=3) {
            this.$dialog.closeLoading();
            this.$dialog.tips({message: "AI主播已开启"})
            this.playVoicePlay();
            break;
          }
          await delay(1000)
        }

      }

    },
    clearAudio(audio) {
      if (!audio) return;
      audio.pause();           // 先停止
      audio.src = '';          // 赋值空
      audio.load();            // 强制浏览器刷新
      audio.onended = null;    // 清空事件

    },
    playVoicePlay() {

      if (!this.$store.state.aiPlayStatus) {
        return;
      }

      if (this.voiceAudioList.length > 0) {
        const blob = this.voiceAudioList.shift();


        this.$store.state.anchorAudio.src = blob
        this.$store.state.anchorAudio.play();
        this.$store.state.anchorAudio.onended = () => {

          console.log("================")
          console.log(this.$store.state.keywordAudio)
          console.log("11111111111111")
          console.log(checkAuduiSrc(this.$store.state.keywordAudio))
          //关键词检测
          if (checkAuduiSrc(this.$store.state.keywordAudio)) {
            this.$store.state.keywordAudio.onended = null;
            this.$store.state.keywordAudio.play().catch((e) => {
              //播放错误
              this.clearAudio(this.$store.state.keywordAudio)
              this.playVoicePlay();
            });

            this.$store.state.keywordAudio.onended = () => {
              this.clearAudio(this.$store.state.keywordAudio)
              this.playVoicePlay();
            }
            if (this.$store.state.channelConfig.dodgeEnabled) {
              return;
            }
          }
          //检测欢迎
          if (checkAuduiSrc(this.$store.state.welcomeAudio)) {
            this.$store.state.welcomeAudio.onended = null;
            this.$store.state.welcomeAudio.play().catch(() => {
              //播放错误
              this.clearAudio(this.$store.state.welcomeAudio)
              this.playVoicePlay();
            });

            this.$store.state.welcomeAudio.onended = (e) => {
              console.log(e)

              this.clearAudio(this.$store.state.welcomeAudio)
              this.playVoicePlay();
            }
            if (this.$store.state.channelConfig.dodgeEnabled) {

              return;
            }
          }


          this.playVoicePlay();
        }
        return;
      }


    },


    async createVoiceList() {
      if (this.$store.state.aiPlayStatus) {
        const arr = this.$store.state.referenceText.split("\n");
        for (let i = 0; i < arr.length; i++) {
          if (!this.$store.state.aiPlayStatus) {
            break;
          }
          const message = [];
          message.push({"role": "system", "content": this.$store.state.appids.replace_id})
          message.push({"role": "user", "content": this.productInfo})
          this.$store.commit("setMessageList", message);

          const text = await chat("", this.$store.state.apiKey, arr[i]).catch((message) => {
            this.$store.state.aiPlayStatus = false;
            this.$dialog.closeLoading();

            this.$dialog.alert({
              title: "温馨提示",
              message
            })
          });
          if (text) {
            const blob = await audioText(text, this.$store.state.voicesConfig?.anchor);
            this.voiceAudioList.push(blob);
          }

        }
        await this.createVoiceList();
      }
    },


    triggerAudioUpload() {
      this.$refs.audioFileInput.click()
    },
    async handleAudioUpload(event) {
      const file = event.target.files[0]

      if (file) {
        this.$dialog.loading({text: "正在识别中，请稍等..."})


        const res = await audioFileToText(file);
        if (res) {
          this.$dialog.closeLoading();
          this.texts = res;
        }
      }
    },

    loadExample() {
      this.saveData("currentExample");

      const example = this.examples[this.currentExample]
      if (example) {
        this.productInfo = example.productInfo
        this.saveData("productInfo")
      }
    },
    async handleAIRobot() {
      this.showAIRobotModal = true
      this.showMoreMenu = false

      const res = await http.get("api/config/index");
      if (res.code == 200) {
        this.$store.commit("setAppids", res.data.talk);
      }


    },
    async handleAPIIntegration() {
      this.showAPIModal = true
      this.showMoreMenu = false

      const res = await http.get("api/ai/getKey");
      if (res.code == 200) {
        this.$store.commit("setApiKey", res.data);
      }


    },
    closeAIRobotModal() {
      this.showAIRobotModal = false

    },
    triggerTextUpload() {
      this.$refs.textFileInput.click()
    },
    downloadText() {
      if (!this.texts || this.texts.trim() === '') {
        this.$dialog.tips({
          message: '请先输入话术内容',
          type: 'error'
        })
        return
      }

      const blob = new Blob([this.texts], {type: 'text/plain;charset=utf-8'})
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      const date = new Date().toLocaleDateString().replace(/\//g, '-')
      link.href = url
      link.download = `话术_${date}.txt`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)

      this.$dialog.tips({
        message: '下载成功',
        type: 'success'
      })
    },
    async handleTextUpload(event) {
      const file = event.target.files[0]
      if (file) {
        if (!file.name.endsWith('.txt')) {
          this.$dialog.tips({
            message: '请选择 .txt 文件',
            type: 'error'
          })
          return
        }

        this.$dialog.loading({text: "正在导入中，请稍等..."})
        const reader = new FileReader()
        reader.onload = (e) => {
          this.texts = e.target.result
          this.$dialog.closeLoading()
          this.$dialog.tips({
            message: '导入成功',
            type: 'success'
          })
        }
        reader.onerror = () => {
          this.$dialog.closeLoading()
          this.$dialog.tips({
            message: '读取文件失败',
            type: 'error'
          })
        }
        reader.readAsText(file, 'utf-8')
      }
    },

    checkConfig() {
      if (!this.apiKey) {
        this.$dialog.tips({
          message: "请先配置秘钥",
          type: 'error'
        })
        return false;
      }
      if (!this.$store.state.voicesConfig.anchor) {
        this.$dialog.tips({
          message: "未配置主播音色",
          type: 'error'
        })
        return false;
      }

      if (!this.referenceText) {
        this.$dialog.tips({
          message: "请填写参考话术",
          type: 'error'
        })
        return false;
      }

      if(this.userReception.enterWelcome){

        if(!this.$store.state.modules.welcome?.id){
          this.$dialog.tips({
            message: "请配置进入欢迎话术",
            type: 'error'
          })
          return false;
        }

      }


      if (this.userReception.enterWelcome || this.userReception.publicReply) {
        if (!this.$store.state.liveWs) {
          this.$dialog.tips({
            message: "请先在直播账号管理中，连接直播间",
            type: 'error'
          })
          return false;
        }
        if (this.$store.state.userReception.useAnchorReply) {
          if (!this.$store.state.voicesConfig.keyword) {
            this.$dialog.tips({
              message: "未配置助播（关键词）音色",
              type: 'error'
            })
            return false;
          }
        }


      }

      return true;

    },

  }
}

</script>

<style scoped>
.voice-reply {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.main-panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 35px;
  position: relative;
  overflow: hidden;
  min-height: 500px;
}

.side-more-services {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  z-index: 10;
}

.side-more-btn {
  position: absolute;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 45px;
  height: 100px;
  border: none;
  border-radius: 0 16px 16px 0;
  background: linear-gradient(180deg, rgba(139, 92, 246, 0.4) 0%, rgba(99, 102, 241, 0.4) 100%);
  border: 1px solid rgba(167, 139, 250, 0.4);
  color: #c4b5fd;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  padding-left: 8px;
  transition: all 0.3s ease;
}

.side-more-btn:hover {
  background: linear-gradient(180deg, rgba(139, 92, 246, 0.5) 0%, rgba(99, 102, 241, 0.5) 100%);
  color: #e9d5ff;
}

.side-more-btn span {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  transform: translateX(-3px);
}

.side-more-btn .arrow {
  font-size: 14px;
  font-weight: bold;
}

.side-more-btn:hover {
  background: linear-gradient(180deg, rgba(139, 92, 246, 0.5) 0%, rgba(99, 102, 241, 0.5) 100%);
  box-shadow: 6px 0 22px rgba(139, 92, 246, 0.35),
  inset 0 1px 0 rgba(167, 139, 250, 0.3);
  transform: translateY(-50%) scale(1.05);
}

.side-more-panel {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 180px;
  background: rgba(35, 35, 35, 0.98);
  border-radius: 12px 0 0 12px;
  padding: 16px 0;
  transition: all 0.3s ease;
  border: 1px solid rgba(170, 170, 170, 0.2);
}

.side-panel-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 12px;
  font-size: 14px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
  border-bottom: 1px solid rgba(170, 170, 170, 0.2);
}

.side-panel-close {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(80, 80, 80, 0.5);
  border: 1px solid rgba(170, 170, 170, 0.2);
  border-radius: 6px;
  color: rgba(170, 170, 170, 0.7);
  cursor: pointer;
  transition: all 0.3s ease;
}

.side-panel-close:hover {
  background: rgba(100, 100, 100, 0.6);
  color: rgba(200, 200, 200, 0.9);
}

.side-panel-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 16px 12px;
  border: none;
  background: transparent;
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  cursor: pointer;
  position: relative;
  z-index: 1;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  border-radius: 8px;
}

.side-panel-item:hover {
  background: rgba(170, 170, 170, 0.1);
  color: #f0f0f0;
}

.item-icon-wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.3) 0%, rgba(167, 139, 250, 0.3) 100%);
  border-radius: 12px;
  border: 1px solid rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.side-panel-item:hover .item-icon-wrapper {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.5) 0%, rgba(167, 139, 250, 0.5) 100%);
  border-color: rgba(102, 126, 234, 0.5);
  transform: scale(1.05);
}

.item-icon-wrapper i {
  font-size: 22px;
  color: rgba(180, 180, 180, 0.9);
}

.side-panel-item:hover .item-icon-wrapper i {
  color: #ffffff;
}

.item-text {
  font-size: 13px;
  font-weight: 500;
}

.tabs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
  margin-bottom: 20px;
  gap: 15px;
}

.tabs-header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.tabs-container {
  display: flex;
  gap: 6px;
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.9) 0%, rgba(25, 25, 25, 0.9) 100%);
  padding: 5px;
  border-radius: 16px;
  border: 1px solid rgba(170, 170, 170, 0.2);
  box-shadow: 0 2px 8px rgba(170, 170, 170, 0.1),
  inset 0 1px 0 rgba(170, 170, 170, 0.1);
}

.tabs-container .tab-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 22px;
  border: none;
  border-radius: 12px;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  color: rgba(170, 170, 170, 0.9);
}

.tab-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: rgba(170, 170, 170, 0.6);
  transition: all 0.3s ease;
}

.tabs-container .tab-btn:hover {
  color: #f0f0f0;
  background: rgba(170, 170, 170, 0.15);
  transform: translateY(-1px);
}

.tab-btn:hover::before {
  left: 10%;
  width: 80%;
}

.tabs-container .tab-btn.active {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.5) 0%, rgba(99, 102, 241, 0.5) 100%);
  color: #c4b5fd !important;
  box-shadow: 0 4px 16px rgba(139, 92, 246, 0.3),
  0 1px 0 rgba(167, 139, 250, 0.3);
  transform: translateY(-1px);
  border: 1px solid rgba(167, 139, 250, 0.5);
}

.tab-btn.active::before {
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.3);
}

.tab-btn i {
  font-size: 14px;
}

.tab-btn.active i {
  color: #e9d5ff;
}

.tab-btn span {
  position: relative;
  z-index: 1;
}

.new-rewrite-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 20px;
  border: 1px solid rgba(80, 80, 80, 0.4);
  border-radius: 8px;
  background: rgba(70, 70, 70, 0.2);
  color: #aaa;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.new-rewrite-btn:hover {
  background: rgba(90, 90, 90, 0.3);
  border-color: rgba(100, 100, 100, 0.5);
}

.add-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 11px 20px;
  border: 1px solid rgba(102, 126, 234, 0.4);
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.4) 0%, rgba(167, 139, 250, 0.4) 100%);
  color: #c4b5fd;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.add-btn:hover {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.5) 0%, rgba(167, 139, 250, 0.5) 100%);
  border-color: rgba(102, 126, 234, 0.6);
  color: #ddd6fe;
  transform: translateY(-1px);
}

.content-area {
  min-height: 400px;
}

.talks-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.talk-card {
  background: rgba(35, 35, 35, 0.95);
  border: 1px solid rgba(170, 170, 170, 0.2);
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
  position: relative;
}

.talk-card:hover {
  transform: translateY(-2px);
  border-color: rgba(170, 170, 170, 0.4);
}

.talk-name {
  font-size: 16px;
  font-weight: 600;
  color: rgba(170, 170, 170, 0.9);
  margin-bottom: 8px;
}

.talk-time {
  font-size: 12px;
  color: #999;
}

.talk-content {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(170, 170, 170, 0.2);
  font-size: 13px;
  color: rgba(150, 150, 150, 0.8);
  line-height: 1.6;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.talk-expand {
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(150, 150, 150, 0.6);
  transition: all 0.3s ease;
}

.talk-expand:hover {
  color: rgba(170, 170, 170, 0.9);
}

.talk-expand.expanded {
  transform: rotate(180deg);
}

.talk-card.expanded {
  padding-bottom: 48px;
}

.talk-actions {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.talk-card:hover .talk-actions {
  opacity: 1;
}

.new-rewrite-card {
  background: rgba(35, 35, 35, 0.95);
  border-color: rgba(170, 170, 170, 0.3);
  cursor: pointer;
}

.new-rewrite-card:hover {
  transform: translateY(-2px);
  border-color: rgba(170, 170, 170, 0.5);
}

.new-rewrite-card .talk-name i {
  font-size: 16px;
  margin-right: 8px;
  color: rgba(170, 170, 170, 0.7);
}

.action-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: rgba(170, 170, 170, 0.1);
  color: rgba(170, 170, 170, 0.9);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.action-btn:hover {
  background: rgba(170, 170, 170, 0.2);
  color: #f0f0f0;
}

.edit-btn {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.4) 0%, rgba(37, 99, 235, 0.4) 100%);
  color: #93c5fd;
  border: 1px solid rgba(147, 197, 253, 0.4);
}

.edit-btn:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.5) 0%, rgba(37, 99, 235, 0.5) 100%);
  color: #bfdbfe;
  border-color: rgba(147, 197, 253, 0.6);
}

.delete-btn {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.4) 0%, rgba(220, 38, 38, 0.4) 100%);
  color: #fca5a5;
  border: 1px solid rgba(248, 113, 113, 0.4);
}

.delete-btn:hover {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.5) 0%, rgba(220, 38, 38, 0.5) 100%);
  color: #fecaca;
  border-color: rgba(248, 113, 113, 0.6);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
  color: rgba(170, 170, 170, 0.5);
}

.empty-state p {
  font-size: 16px;
  margin-bottom: 20px;
}

/* API对接弹窗样式 */
.api-modal {
  width: 100%;
  max-width: calc(100vw - 20px);
  max-height: calc(100vh - 40px);
  overflow-y: auto;
}

.api-header {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 12px 12px 0 0;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.api-header .modal-title {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.api-body {
  padding: 30px;
  background: #1e1e24;
}

.engine-selector {
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-bottom: 30px;
}

.engine-card {
  width: 160px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(60, 60, 65, 0.8) 0%, rgba(45, 45, 50, 0.8) 100%);
  border: 2px solid transparent;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  text-align: center;
}

.engine-card:hover {
  transform: translateY(-4px);
}

.engine-card.active {
  border-color: rgba(139, 92, 246, 0.6);
  box-shadow: 0 0 20px rgba(139, 92, 246, 0.3);
}

.engine-icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  font-size: 24px;
  color: #fff;
}

.volcano-icon {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #ec4899 100%);
}

.tongyi-icon {
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 50%, #1d4ed8 100%);
}

.engine-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  color: #fff;
}

.engine-card.active .engine-badge {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
}

.engine-card:not(.active) .engine-badge {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.engine-name {
  display: block;
  color: #e5e7eb;
  font-size: 14px;
  font-weight: 500;
}

.api-input-section {
  margin-bottom: 16px;
}

.api-label {
  display: block;
  color: #9ca3af;
  font-size: 13px;
  margin-bottom: 8px;
}

.input-with-tip {
  position: relative;
}

.api-input {
  width: 100%;
  padding: 12px 14px;
  background: rgba(55, 55, 60, 0.8);
  border: 1px solid rgba(80, 80, 90, 0.6);
  border-radius: 10px;
  color: #e5e7eb;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.api-input:focus {
  border-color: rgba(139, 92, 246, 0.6);
  box-shadow: 0 0 0 0.2rem rgba(139, 92, 246, 0.15);
}

.api-input::placeholder {
  color: #6b7280;
}

.input-tip {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  font-size: 12px;
}

.api-tip-section {
  text-align: center;
}

.api-tip {
  color: #6b7280;
  font-size: 12px;
}

.api-footer {
  padding: 16px 24px;
  background: #18181c;
  border-radius: 0 0 12px 12px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-outline {
  padding: 10px 20px;
  border: 1px solid rgba(70, 70, 80, 0.8);
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(55, 55, 60, 0.95) 0%, rgba(45, 45, 50, 0.95) 100%);
  color: #d1d5db;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background: linear-gradient(135deg, rgba(70, 70, 75, 0.95) 0%, rgba(55, 55, 60, 0.95) 100%);
  color: #fff;
  border-color: rgba(100, 100, 110, 0.8);
}

.btn-test {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.9) 0%, rgba(234, 88, 12, 0.9) 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-test:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
}

.api-submit {
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.9) 0%, rgba(22, 163, 74, 0.9) 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.api-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.4);
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.modal-container {
  width: 90%;
  max-width: 500px;
  animation: modalIn 0.3s ease;
}

.modal-wrapper {
  background: rgba(35, 35, 35, 0.98);
  border: 1px solid rgba(170, 170, 170, 0.2);
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: rgba(170, 170, 170, 0.2);
}

.modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.modal-close {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 20px;
  cursor: pointer;
  padding: 6px 10px;
  transition: all 0.3s ease;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

.modal-body {
  padding: 24px;
}

.ai-robot-modal .modal-body {
  max-height: 70vh;
  overflow-y: auto;

}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(170, 170, 170, 0.9);
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid rgba(170, 170, 170, 0.3);
  border-radius: 10px;
  background: rgba(35, 35, 35, 0.9);
  color: rgba(170, 170, 170, 0.9);
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: rgba(170, 170, 170, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(170, 170, 170, 0.15);
}

.form-input::placeholder {
  color: #777;
}

.form-textarea {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 10px;
  background: #2a2a2a;
  color: #ccc;
  font-size: 14px;
  min-height: 80px;
  resize: vertical;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-textarea:focus {
  outline: none;
  border-color: #888;
  box-shadow: 0 0 0 0.2rem rgba(100, 100, 100, 0.2);
}

.form-textarea::placeholder {
  color: #777;
}

/* AI话术助手弹窗样式 */
.modal-container-wide {
  width: 95%;
  max-width: 1200px;
  animation: modalIn 0.3s ease;
}

.ai-content {
  display: flex;
  gap: 24px;
}

.ai-panel {
  flex: 1;
  background: rgba(40, 40, 45, 0.95);
  border-radius: 16px;
  border: 1px solid rgba(80, 80, 85, 0.6);
  overflow: hidden;
}

.ai-panel .panel-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%);
  border-bottom: 1px solid rgba(139, 92, 246, 0.2);
}

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(99, 102, 241, 0.3) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a78bfa;
  font-size: 16px;
}

.panel-icon.write-icon {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.3) 0%, rgba(14, 165, 233, 0.3) 100%);
  color: #60a5fa;
}

.panel-title {
  font-size: 16px;
  font-weight: 600;
  color: #f0f0f0;
  margin: 0;
}

.ai-panel .panel-body {
  padding: 24px;
}

.upload-box {
  border: 2px dashed rgba(139, 92, 246, 0.4);
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  background: rgba(30, 30, 35, 0.8);
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 14px;
}

.upload-box:hover {
  border-color: rgba(139, 92, 246, 0.8);
  background: rgba(40, 40, 45, 0.9);
}

.upload-icon-wrapper {
  width: 40px;
  height: 40px;
  margin: 0 auto 10px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.25) 0%, rgba(99, 102, 241, 0.25) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #a78bfa;
  transition: transform 0.3s ease;
}

.upload-box:hover .upload-icon-wrapper {
  transform: scale(1.1);
}

.upload-tip {
  color: #ccc;
  font-size: 13px;
  margin: 8px 0;
  line-height: 1.6;
}

.upload-format {
  color: #777;
  font-size: 12px;
  margin: 0;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  color: #aaa;
  font-size: 13px;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-textarea-large {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid rgba(80, 80, 80, 0.5);
  border-radius: 10px;
  background: rgba(30, 30, 35, 0.8);
  color: #ccc;
  font-size: 14px;
  min-height: 355px;
  resize: vertical;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-textarea-large:focus {
  outline: none;
  border-color: rgba(139, 92, 246, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(139, 92, 246, 0.1);
}

.form-textarea-large::placeholder {
  color: #777;
}

.btn-rewrite {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-rewrite:hover {
  background: linear-gradient(135deg, rgba(139, 92, 246, 1) 0%, rgba(99, 102, 241, 1) 100%);
  box-shadow: 0 4px 15px rgba(139, 92, 246, 0.4);
  transform: translateY(-1px);
}

.btn-write {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.8) 0%, rgba(14, 165, 233, 0.8) 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-write:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 1) 0%, rgba(14, 165, 233, 1) 100%);
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.4);
  transform: translateY(-1px);
}

.image-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.image-section {
  width: 100%;
}

.upload-area {
  border: 2px dashed rgba(139, 92, 246, 0.5);
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  background: rgba(35, 35, 35, 0.8);
  transition: all 0.3s ease;
  cursor: pointer;
}

.upload-area:hover {
  border-color: rgba(139, 92, 246, 0.8);
  background: rgba(45, 45, 45, 0.9);
}

.upload-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(99, 102, 241, 0.3) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #a78bfa;
}

.upload-area p {
  color: #ccc;
  margin: 8px 0;
  font-size: 14px;
}

.upload-hint {
  color: #777 !important;
  font-size: 12px !important;
}

.textarea-section {
  width: 100%;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  background: #252525;
}

/* 按钮样式 */
.btn {
  padding: 10px 24px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background: rgba(170, 170, 170, 0.2);
  color: rgba(170, 170, 170, 0.9);
  border: 1px solid rgba(170, 170, 170, 0.3);
}

.add-btn:hover {
  transform: translateY(-2px);
  background: rgba(170, 170, 170, 0.3);
  color: #f0f0f0;
}

.btn-secondary {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.6) 0%, rgba(75, 85, 99, 0.6) 100%);
  color: #d1d5db;
  border: 1px solid rgba(156, 163, 175, 0.5);
}

.btn-secondary:hover {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.7) 0%, rgba(75, 85, 99, 0.7) 100%);
  border-color: rgba(156, 163, 175, 0.7);
}

@keyframes modalIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .voice-reply {
    padding: 12px;
  }

  .tabs-header {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .tabs-container {
    flex-wrap: wrap;
    justify-content: center;
  }

  .tab-btn {
    padding: 10px 16px;
    font-size: 13px;
  }

  .add-btn {
    justify-content: center;
  }

  .content-area {
    padding: 16px;
  }

  .talks-grid {
    grid-template-columns: 1fr;
  }
}

/* AI替你播弹窗样式 */
.ai-robot-modal {
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 20px;
}

.ai-robot-header {
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.2) 0%, rgba(239, 68, 68, 0.2) 100%);
  border-bottom: 1px solid rgba(251, 146, 60, 0.3);
}

.header-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.8) 0%, rgba(239, 68, 68, 0.8) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  margin-right: 12px;
}

.ai-robot-content {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.robot-panel {
  flex: 1;
  background: rgba(40, 40, 45, 0.95);
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(80, 80, 85, 0.5);
}

.robot-panel.left-panel {
  border-color: rgba(251, 146, 60, 0.3);
}

.robot-panel.right-panel {
  border-color: rgba(59, 130, 246, 0.3);
}

.robot-header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  gap: 10px;
}

.header-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: auto;
  margin-right: 0;
}

.text-file-input {
  display: none;
}

.text-btn {
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}

.text-btn-import {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.text-btn-import:hover {
  background: rgba(16, 185, 129, 0.2);
}

.text-btn-export {
  background: rgba(251, 146, 60, 0.2);
  color: #fb923c;
  border: 1px solid rgba(251, 146, 60, 0.4);
}

.text-btn-export:hover {
  background: rgba(251, 146, 60, 0.3);
}

.panel-icon.orange-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.3) 0%, rgba(239, 68, 68, 0.3) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fb923c;
}

.panel-icon.blue-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.3) 0%, rgba(14, 165, 233, 0.3) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #3b82f6;
}

.word-count {
  margin-left: auto;
  background: rgba(251, 146, 60, 0.2);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  color: #fb923c;
}

.audio-upload-section {
  margin-top: 16px;
  border-top: 1px solid #e5e7eb;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.audio-upload-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  background: rgba(139, 92, 246, 0.1);
  border: 1px dashed #8b5cf6;
  border-radius: 8px;
  color: #8b5cf6;
  cursor: pointer;
  transition: all 0.2s ease;
}

.audio-upload-btn:hover {
  background: rgba(139, 92, 246, 0.2);
  border-color: #7c3aed;
}

.audio-file-input {
  display: none;
}


.audio-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  color: #374151;
  font-size: 14px;
}

.audio-info i {
  color: #8b5cf6;
}

.audio-play-btn,
.audio-delete-btn,
.audio-download-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.audio-play-btn {
  background: rgba(139, 92, 246, 0.1);
  color: #8b5cf6;
}

.audio-play-btn:hover {
  background: rgba(139, 92, 246, 0.2);
}

.audio-delete-btn {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.audio-delete-btn:hover {
  background: rgba(239, 68, 68, 0.2);
}

.audio-download-btn {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.audio-download-btn:hover {
  background: rgba(16, 185, 129, 0.2);
}

.download-section {
  margin: 12px 0;
  display: none;
}

.example-dropdown {
  margin-left: auto;
  position: relative;
}

.example-dropdown select {
  appearance: none;
  background: linear-gradient(135deg, rgba(60, 60, 65, 0.9) 0%, rgba(45, 45, 50, 0.9) 100%);
  border: 1px solid rgba(80, 80, 90, 0.6);
  border-radius: 10px;
  padding: 8px 32px 8px 14px;
  color: #e5e7eb;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  min-width: 120px;
  transition: all 0.3s ease;
}

.example-dropdown::after {
  content: '\f078';
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  pointer-events: none;
  font-size: 12px;
}

.example-dropdown select:hover {
  background: linear-gradient(135deg, rgba(70, 70, 75, 0.95) 0%, rgba(55, 55, 60, 0.95) 100%);
  border-color: rgba(100, 100, 110, 0.8);
  color: #f3f4f6;
}

.example-dropdown select:focus {
  border-color: rgba(251, 146, 60, 0.6);
  box-shadow: 0 0 0 0.2rem rgba(251, 146, 60, 0.15), 0 0 15px rgba(251, 146, 60, 0.1);
}

.example-dropdown select option {
  background: #2a2a30;
  color: #e5e7eb;
  padding: 8px 12px;
}

.example-dropdown select option:hover {
  background: rgba(251, 146, 60, 0.3);
}

.example-dropdown select option:checked {
  background: rgba(251, 146, 60, 0.4);
  color: #fb923c;
}

.textarea-container {
  position: relative;
}

.robot-textarea {
  width: 100%;
  height: 265px;
  padding: 14px;
  padding-bottom: 36px;
  border: none;
  border-radius: 8px;
  background: rgba(30, 30, 35, 0.9);
  color: #ccc;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
  font-family: inherit;
}

.word-count-floating {
  position: absolute;
  bottom: 10px;
  right: 14px;
  font-size: 12px;
  color: #fb923c;
  background: rgba(251, 146, 60, 0.2);
  padding: 4px 10px;
  border-radius: 12px;
}

.robot-textarea:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(251, 146, 60, 0.2);
}

.char-count {
  text-align: right;
  font-size: 12px;
  color: #666;
  margin-top: 8px;
}

.product-info-panel {
  padding: 16px;
}

.product-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.product-row.full-width {
  flex-direction: column;
}

.product-item {
  flex: 1;
}

.product-item.full {
  width: 100%;
}

.product-item label {
  display: block;
  font-size: 12px;
  color: #888;
  margin-bottom: 6px;
}

.product-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(80, 80, 85, 0.5);
  border-radius: 8px;
  background: rgba(30, 30, 35, 0.8);
  color: #ccc;
  font-size: 13px;
  box-sizing: border-box;
}

.product-input:focus {
  outline: none;
  border-color: rgba(59, 130, 246, 0.5);
}

.product-textarea {
  width: 100%;
  min-height: 300px;
  padding: 10px 12px;
  border: 1px solid rgba(80, 80, 85, 0.5);
  border-radius: 8px;
  background: rgba(30, 30, 35, 0.8);
  color: #ccc;
  font-size: 13px;
  resize: vertical;
  box-sizing: border-box;
  font-family: inherit;
}

.product-textarea:focus {
  outline: none;
  border-color: rgba(59, 130, 246, 0.5);
}

.service-options {
  margin-top: 12px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #aaa;
}

.checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #3b82f6;
}

.checkbox-label input[type="number"] {
  width: 60px;
  padding: 4px 8px;
  border: 1px solid rgba(80, 80, 85, 0.5);
  border-radius: 6px;
  background: rgba(30, 30, 35, 0.8);
  color: #ccc;
  font-size: 12px;
  text-align: center;
}

.mini-input {
  width: 50px !important;
}

.practice-section,
.config-section {
  background: rgba(40, 40, 45, 0.8);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 16px;
  border: 1px solid rgba(80, 80, 85, 0.4);
  flex: 1;
}

.sections-row {
  display: flex;
  gap: 16px;
}

.section-header {
  margin-bottom: 12px;
}

.section-header h4 {
  margin: 0;
  font-size: 14px;
  color: #ddd;
  font-weight: 500;
}

.practice-options,
.config-options {
  display: flex;
  gap: 20px;

}

.btn-start {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.8) 0%, rgba(239, 68, 68, 0.8) 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}


.btn-start:hover {
  background: linear-gradient(135deg, rgba(251, 146, 60, 1) 0%, rgba(239, 68, 68, 1) 100%);
  box-shadow: 0 4px 15px rgba(251, 146, 60, 0.4);
  transform: translateY(-1px);
}

.btn-start-active {
  background: linear-gradient(135deg, rgba(36, 169, 251, 0.8) 0%, rgba(2, 113, 255, 0.8) 100%);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 14px;

}

.btn-start-active:hover {
  background: linear-gradient(135deg, rgba(36, 169, 251, 1) 0%, rgba(2, 113, 255, 1) 100%);
  box-shadow: 0 4px 15px rgba(251, 146, 60, 0.4);
  transform: translateY(-1px);
}


/* AI替你播响应式 */
@media (max-width: 900px) {
  .ai-robot-content {
    flex-direction: column;
  }

  .practice-options,
  .config-options {
    flex-direction: column;
  }
}
</style>
